<template>
  <Registrants v-bind="$props" v-on="$listeners">
    <template #table.item.action="slotProps">
      <ProgressBackwardItemAction v-bind="slotProps" v-on="slotProps.on" />
    </template>
  </Registrants>
</template>

<script>
import Registrants from "./Registrants"
import { ProgressBackwardItemAction } from "./base/table"
import moment from "moment"

export default {
  name: "LegalProcess",
  components: {
    Registrants,
    ProgressBackwardItemAction,
  },
  props: {
    resourcePath: {
      type: String,
      default: "legalProcesses",
    },
    title: {
      type: String,
      default: "Legal Process",
    },
    subject: {
      type: String,
      default: "Legal Process",
    },
    headers: {
      type: Array,
      default: function () {
        return [
          {
            text: "Id",
            value: this.$config("applicant.id"),
          },
          {
            text: "Name",
            value: "name",
            customValue: function (item) {
              return `${item.profile.last_name}, ${item.profile.first_name}`
            },
          },
          {
            text: "Email",
            value: "email",
          },
          {
            text: "Country",
            value: "profile.address.country",
          },
          {
            text: "Date Registered",
            value: "created_at",
            customValue: function (item) {
              return moment.unix(item.created_at).format("MMM. D, YYYY")
            },
          },
          {
            text: "Phone",
            value: "profile.phone",
          },
          {
            text: "Status",
            value: "profile.status",
            align: "center",
          },
          {
            text: "Action",
            value: "action",
            align: "center",
            filterable: false,
          },
          {
            text: "Category",
            value: "category",
            align: "center",
          },
        ]
      },
    },
  },
}
</script>
